/* ============================================================
   ATELIER BY T&A — Main JavaScript
   ============================================================ */

document.addEventListener('DOMContentLoaded', function () {

  // ── MONEY FORMAT ──
  // Uses Shopify's shop.money_format (e.g. "${{amount}} AUD") set in theme.liquid
  function formatMoney(cents) {
    var amount = (cents / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    var fmt = (window.ATELIER && window.ATELIER.moneyFormat) || '${{amount}}';
    return fmt.replace('{{amount}}', amount)
              .replace('{{amount_no_decimals}}', String(Math.round(cents / 100)))
              .replace('{{amount_with_comma_separator}}', amount.replace('.', ',').replace(/,(\d{3})/g, '.$1'))
              .replace('{{amount_no_decimals_with_comma_separator}}', String(Math.round(cents / 100)));
  }

  // ── CART DRAWER ──
  var cartDrawer = document.getElementById('cart-drawer');
  var cartDrawerOverlay = document.getElementById('cart-drawer-overlay');
  var cartDrawerClose = document.getElementById('cart-drawer-close');
  var cartDrawerBody = document.getElementById('cart-drawer-body');
  var cartDrawerFooter = document.getElementById('cart-drawer-footer');
  var cartDrawerSubtotal = document.getElementById('cart-drawer-subtotal');
  var cartDrawerProgressFill = document.getElementById('cart-drawer-progress-fill');
  var cartDrawerProgressMsg = document.getElementById('cart-drawer-progress-msg');

  function openCartDrawer() {
    if (!cartDrawer) return;
    refreshCartDrawer();
    cartDrawer.classList.add('open');
    cartDrawer.setAttribute('aria-hidden', 'false');
    document.body.classList.add('cart-drawer-open');
  }

  function closeCartDrawer() {
    if (!cartDrawer) return;
    cartDrawer.classList.remove('open');
    cartDrawer.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('cart-drawer-open');
  }

  function refreshCartDrawer() {
    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) { renderCartDrawer(cart); });
  }

  function renderCartDrawer(cart) {
    document.querySelectorAll('.cart-count').forEach(function (el) {
      el.textContent = cart.item_count;
    });

    var threshold = (window.ATELIER && window.ATELIER.freeShippingThreshold) || 15000;
    var pct = Math.min(cart.total_price / threshold * 100, 100);
    if (cartDrawerProgressFill) cartDrawerProgressFill.style.width = pct + '%';
    if (cartDrawerProgressMsg) {
      cartDrawerProgressMsg.textContent = cart.total_price >= threshold
        ? '✦ You’ve unlocked free shipping!'
        : 'You’re ' + formatMoney(threshold - cart.total_price) + ' away from free shipping';
    }

    if (!cartDrawerBody) return;

    if (cart.item_count === 0) {
      cartDrawerBody.innerHTML = '<div class="cart-drawer-empty"><p>Your cart is empty.</p><a href="/collections/all">Continue Shopping</a></div>';
      if (cartDrawerFooter) cartDrawerFooter.style.display = 'none';
      return;
    }

    cartDrawerBody.innerHTML = cart.items.map(function (item, idx) {
      var imgUrl = item.featured_image && item.featured_image.url;
      var imgSrc = imgUrl ? imgUrl + (imgUrl.indexOf('?') >= 0 ? '&' : '?') + 'width=160' : '';
      var imgHtml = imgSrc ? '<img src="' + imgSrc + '" alt="' + (item.title || '').replace(/"/g, '&quot;') + '" loading="lazy" width="80">' : '';
      var variantHtml = item.variant_title && item.variant_title !== 'Default Title'
        ? '<p class="cart-drawer-item-variant">' + item.variant_title + '</p>' : '';
      return [
        '<div class="cart-drawer-item" data-line="' + (idx + 1) + '" data-unit-price="' + item.price + '">',
        '<div class="cart-drawer-item-img">' + imgHtml + '</div>',
        '<div>',
        '<p class="cart-drawer-item-name">' + item.product_title + '</p>',
        variantHtml,
        '<div class="cart-drawer-item-row">',
        '<div class="cart-qty-control">',
        '<button type="button" class="qty-btn drawer-qty-btn" data-action="minus">−</button>',
        '<span class="qty-display">' + item.quantity + '</span>',
        '<button type="button" class="qty-btn drawer-qty-btn" data-action="plus">+</button>',
        '</div>',
        '<span class="cart-drawer-item-price">' + formatMoney(item.line_price) + '</span>',
        '</div>',
        '</div>',
        '</div>'
      ].join('');
    }).join('');

    cartDrawerBody.querySelectorAll('.cart-drawer-item').forEach(function (itemEl) {
      itemEl.querySelectorAll('.drawer-qty-btn').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var display = itemEl.querySelector('.qty-display');
          var line = parseInt(itemEl.dataset.line, 10);
          var val = parseInt(display.textContent, 10) || 1;
          if (btn.dataset.action === 'plus') val = Math.min(val + 1, 99);
          if (btn.dataset.action === 'minus') val = Math.max(val - 1, 0);
          display.textContent = val;
          display.style.opacity = '0.4';
          itemEl.querySelectorAll('.drawer-qty-btn').forEach(function (b) { b.disabled = true; });
          fetch('/cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ line: line, quantity: val })
          })
          .then(function (r) { return r.json(); })
          .then(function (updatedCart) { renderCartDrawer(updatedCart); })
          .catch(function () {
            display.style.opacity = '';
            itemEl.querySelectorAll('.drawer-qty-btn').forEach(function (b) { b.disabled = false; });
          });
        });
      });
    });

    if (cartDrawerFooter) cartDrawerFooter.style.display = '';
    if (cartDrawerSubtotal) cartDrawerSubtotal.textContent = formatMoney(cart.total_price);
  }

  document.querySelectorAll('[data-open-cart]').forEach(function (el) {
    el.addEventListener('click', function (e) { e.preventDefault(); openCartDrawer(); });
  });
  if (cartDrawerClose) cartDrawerClose.addEventListener('click', closeCartDrawer);
  if (cartDrawerOverlay) cartDrawerOverlay.addEventListener('click', closeCartDrawer);

  // Initialize progress bar on page load
  if (cartDrawerProgressFill) {
    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var threshold = (window.ATELIER && window.ATELIER.freeShippingThreshold) || 15000;
        var pct = Math.min(cart.total_price / threshold * 100, 100);
        cartDrawerProgressFill.style.width = pct + '%';
        if (cartDrawerProgressMsg) {
          cartDrawerProgressMsg.textContent = cart.total_price >= threshold
            ? '✦ You’ve unlocked free shipping!'
            : 'You’re ' + formatMoney(threshold - cart.total_price) + ' away from free shipping';
        }
      });
  }

  // ── PRODUCT GALLERY THUMBNAILS ──
  var thumbs = document.querySelectorAll('.product-gallery-thumb');
  var mainImg = document.getElementById('product-main-img');
  thumbs.forEach(function (thumb) {
    thumb.addEventListener('click', function () {
      thumbs.forEach(function (t) { t.classList.remove('active'); });
      thumb.classList.add('active');
      if (mainImg) {
        if (thumb.dataset.src) mainImg.src = thumb.dataset.src;
        if (thumb.dataset.zoomSrc) mainImg.dataset.zoomSrc = thumb.dataset.zoomSrc;
      }
    });
  });

  // ── IMAGE ZOOM ──
  var zoomOverlay = document.getElementById('img-zoom-overlay');
  var zoomImg = document.getElementById('img-zoom-img');
  var zoomClose = document.getElementById('img-zoom-close');

  function openZoom(src, alt) {
    if (!zoomOverlay || !zoomImg) return;
    zoomImg.src = src;
    zoomImg.alt = alt || '';
    zoomOverlay.classList.add('open');
    zoomOverlay.setAttribute('aria-hidden', 'false');
    document.body.classList.add('zoom-open');
  }

  function closeZoom() {
    if (!zoomOverlay) return;
    zoomOverlay.classList.remove('open');
    zoomOverlay.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('zoom-open');
  }

  if (mainImg) {
    mainImg.addEventListener('click', function () {
      openZoom(mainImg.dataset.zoomSrc || mainImg.src, mainImg.alt);
    });
  }
  if (zoomClose) zoomClose.addEventListener('click', closeZoom);
  if (zoomOverlay) {
    zoomOverlay.addEventListener('click', function (e) {
      if (e.target === zoomOverlay) closeZoom();
    });
  }

  // ── VARIANT SELECTION (product page) ──
  var variantsJson = document.getElementById('product-variants-json');
  var variantInput = document.getElementById('product-variant-id');
  var swatches = document.querySelectorAll('.variant-swatch');
  var variants = [];
  try {
    variants = variantsJson ? JSON.parse(variantsJson.textContent) : [];
  } catch (err) {
    variants = [];
  }

  function findMatchingVariant() {
    if (!variants.length) return null;

    var swatchGroups = document.querySelectorAll('.variant-swatches');
    if (!swatchGroups.length) return variants[0];

    var selected = [];
    var i;
    for (i = 0; i < swatchGroups.length; i++) {
      var active = swatchGroups[i].querySelector('.variant-swatch.active');
      if (!active) return null;
      selected[parseInt(active.dataset.option, 10) - 1] = active.dataset.value;
    }

    return variants.find(function (v) {
      return ['option1', 'option2', 'option3'].every(function (key, idx) {
        if (v[key] == null) return true;
        return selected[idx] === v[key];
      });
    }) || null;
  }

  function imageUrlBase(url) {
    return url ? url.split('?')[0].replace(/^https?:/, '') : '';
  }

  function updateVariantImage(match) {
    if (!mainImg || !match || !match.featured_image) return;
    var src = match.featured_image.src;
    if (!src) return;
    var displaySrc = src + (src.indexOf('?') >= 0 ? '&' : '?') + 'width=900';
    var zoomSrc = src + (src.indexOf('?') >= 0 ? '&' : '?') + 'width=1600';
    var base = imageUrlBase(src);
    mainImg.src = displaySrc;
    mainImg.dataset.zoomSrc = zoomSrc;
    thumbs.forEach(function (thumb) {
      thumb.classList.toggle('active', imageUrlBase(thumb.dataset.src) === base);
    });
  }

  function syncSelectedVariant() {
    if (!variantInput || !variants.length) return;

    var match = findMatchingVariant();
    var atcBtn = document.getElementById('add-to-cart-btn');
    var atcLabel = document.getElementById('atc-label');
    var atcPrice = document.getElementById('atc-price');
    var priceEl = document.getElementById('product-price');
    var compareEl = document.querySelector('.product-detail-price .compare-price');
    var stickyPrice = document.getElementById('sticky-atc-price');
    var stickyBtn = document.getElementById('sticky-atc-btn');

    if (!match) {
      if (atcBtn) atcBtn.disabled = true;
      if (stickyBtn) stickyBtn.disabled = true;
      if (atcLabel) atcLabel.textContent = 'Unavailable';
      return;
    }

    variantInput.value = String(match.id);
    variantInput.setAttribute('value', String(match.id));
    if (priceEl) {
      priceEl.textContent = formatMoney(match.price);
      priceEl.style.color = match.compare_at_price > match.price ? '#6b3a2a' : '';
    }
    if (compareEl) {
      if (match.compare_at_price > match.price) {
        compareEl.textContent = formatMoney(match.compare_at_price);
        compareEl.style.display = '';
      } else {
        compareEl.style.display = 'none';
      }
    }
    if (atcPrice) atcPrice.textContent = formatMoney(match.price);
    if (stickyPrice) stickyPrice.textContent = formatMoney(match.price);
    if (atcBtn) atcBtn.disabled = !match.available;
    if (stickyBtn) stickyBtn.disabled = !match.available;
    if (atcLabel) atcLabel.textContent = match.available ? 'Add to Cart' : 'Sold Out';
    updateVariantImage(match);
  }

  swatches.forEach(function (swatch) {
    swatch.addEventListener('click', function () {
      var group = swatch.closest('.variant-swatches');
      if (group) {
        group.querySelectorAll('.variant-swatch').forEach(function (s) { s.classList.remove('active'); });
      }
      swatch.classList.add('active');
      syncSelectedVariant();
    });
  });

  syncSelectedVariant();

  // ── PRODUCT PAGE ADD TO CART ──
  var atcBtnEl = document.getElementById('add-to-cart-btn');
  if (atcBtnEl) {
    atcBtnEl.addEventListener('click', function (e) {
      e.preventDefault();
      if (atcBtnEl.disabled) return;

      syncSelectedVariant();
      var match = findMatchingVariant();
      var vid = match ? match.id : (variantInput ? parseInt(variantInput.value, 10) : null);
      if (!vid) return;

      var labelEl = document.getElementById('atc-label');
      atcBtnEl.disabled = true;
      if (labelEl) labelEl.textContent = 'Adding…';

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: vid, quantity: 1 })
      })
      .then(function (r) {
        if (!r.ok) throw new Error();
        return r.json();
      })
      .then(function () {
        if (labelEl) labelEl.textContent = 'Added ✦';
        openCartDrawer();
      })
      .catch(function () {
        if (labelEl) labelEl.textContent = 'Sold Out';
      })
      .finally(function () {
        setTimeout(syncSelectedVariant, 1800);
      });
    });
  }

  // ── CART PAGE QTY CONTROLS ──
  document.querySelectorAll('.cart-page .qty-btn').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var control = btn.closest('.cart-qty-control');
      var cartItem = btn.closest('.cart-item');
      var display = control && control.querySelector('.qty-display');
      if (!display || !cartItem) return;

      var val = parseInt(display.textContent, 10) || 1;
      if (btn.dataset.action === 'plus') val = Math.min(val + 1, 99);
      if (btn.dataset.action === 'minus') val = Math.max(val - 1, 0);

      var line = cartItem.dataset.line;
      var unitPrice = parseInt(cartItem.dataset.unitPrice, 10) || 0;
      var allBtns = cartItem.querySelectorAll('.qty-btn');

      display.textContent = val;
      display.style.opacity = '0.4';
      allBtns.forEach(function (b) { b.disabled = true; b.style.opacity = '0.3'; });

      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ line: line, quantity: val })
      })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        if (val === 0) {
          cartItem.remove();
          if (cart.item_count === 0) location.reload();
          return;
        }
        var priceEl = cartItem.querySelector('.cart-item-price');
        if (priceEl) priceEl.textContent = formatMoney(unitPrice * val);
        var subtotal = document.getElementById('cart-subtotal');
        var total = document.getElementById('cart-total');
        if (subtotal) subtotal.textContent = formatMoney(cart.total_price);
        if (total) total.textContent = formatMoney(cart.total_price);
        document.querySelectorAll('.cart-count').forEach(function (el) { el.textContent = cart.item_count; });
      })
      .finally(function () {
        display.style.opacity = '';
        allBtns.forEach(function (b) { b.disabled = false; b.style.opacity = ''; });
      });
    });
  });

  // ── STICKY HEADER SHADOW ──
  var header = document.querySelector('.site-header');
  if (header) {
    window.addEventListener('scroll', function () {
      header.style.borderBottomColor = window.scrollY > 10 ? 'rgba(0,0,0,0.12)' : '';
    });
  }

  // ── PRODUCT CARD ADD TO CART (AJAX) ──
  function bindAddToCart(btn) {
    btn.addEventListener('click', function () {
      var variantId = btn.dataset.variantId;
      if (!variantId || btn.disabled) return;

      var original = btn.textContent;
      btn.disabled = true;
      btn.textContent = 'Adding…';

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: parseInt(variantId, 10), quantity: 1 })
      })
      .then(function (r) {
        if (!r.ok) throw new Error('add-failed');
        return r.json();
      })
      .then(function () {
        btn.textContent = 'Added ✦';
        openCartDrawer();
      })
      .catch(function () {
        btn.textContent = 'Sold Out';
      })
      .finally(function () {
        setTimeout(function () {
          btn.textContent = original;
          btn.disabled = false;
        }, 1800);
      });
    });
  }

  document.querySelectorAll('.product-add-btn').forEach(bindAddToCart);

  // ── COLLECTION GLOBAL AVAILABILITY SORT ──
  var collectionEl = document.querySelector('.collection-products[data-handle]');
  if (collectionEl) {
    var handle = collectionEl.dataset.handle;
    var PAGE_SIZE = 12;
    var params = new URLSearchParams(window.location.search);
    var sortBy = params.get('sort_by') || 'manual';
    var currentPage = parseInt(params.get('page'), 10) || 1;

    function cdnImg(src, w) {
      if (!src) return '';
      return src + (src.indexOf('?') >= 0 ? '&' : '?') + 'width=' + w;
    }

    function buildCard(p) {
      var avail = p.variants.some(function (v) { return v.available; });
      var fv = p.variants[0];
      var price = parseFloat(fv.price) || 0;
      var compareAt = parseFloat(fv.compare_at_price) || 0;
      var onSale = compareAt > price;
      var badge = '';
      if (!avail) badge = '<span class="product-badge sale">Sold Out</span>';
      else if (onSale) badge = '<span class="product-badge sale">Sale</span>';
      else if (p.tags.indexOf('new') !== -1) badge = '<span class="product-badge new">New</span>';
      else if (p.tags.indexOf('bestseller') !== -1) badge = '<span class="product-badge best">Bestseller</span>';
      var firstAvail = p.variants.find(function (v) { return v.available; }) || fv;
      var img = p.images[0];
      var alt = (img && img.alt ? img.alt : p.title).replace(/"/g, '&quot;');
      var imgHtml = img
        ? '<a href="/products/' + p.handle + '"><img src="' + cdnImg(img.src, 500) + '" srcset="' + cdnImg(img.src, 400) + ' 400w,' + cdnImg(img.src, 600) + ' 600w,' + cdnImg(img.src, 800) + ' 800w" sizes="(max-width:768px) 50vw, 25vw" alt="' + alt + '" loading="lazy" width="500"></a>'
        : '<a href="/products/' + p.handle + '" class="product-img-placeholder"><span style="font-size:32px;opacity:0.15;letter-spacing:-4px;">✦</span><span>Atelier by T&amp;A</span></a>';
      var priceStr = formatMoney(Math.round(price * 100)) + (onSale ? '<span class="compare-price">' + formatMoney(Math.round(compareAt * 100)) + '</span>' : '');
      var vc = p.variants.length;
      var fvt = fv.title !== 'Default Title' ? fv.title : '';
      var meta = (p.vendor ? p.vendor + ' · ' : '') + (vc > 1 ? vc + ' options' : fvt);
      var addBtnHtml = avail
        ? '<button class="product-add-btn" data-product-id="' + p.id + '" data-variant-id="' + firstAvail.id + '" aria-label="Add ' + p.title.replace(/"/g, '&quot;') + ' to cart">Add to Cart</button>'
        : '';
      return '<div class="product-card"><div class="product-card-img">' + badge + imgHtml + addBtnHtml +
        '</div><a href="/products/' + p.handle + '"><p class="product-name">' + p.title + '</p></a>' +
        '<p class="product-meta">' + meta + '</p>' +
        '<p class="product-price' + (onSale ? ' on-sale' : '') + '">' + priceStr + '</p></div>';
    }

    function buildPagination(cur, total) {
      if (total <= 1) return '';
      var base = window.location.pathname;
      var sq = sortBy !== 'manual' ? '&sort_by=' + sortBy : '';
      var h = '<nav class="pagination" aria-label="Pagination">';
      if (cur > 1) h += '<a href="' + base + '?page=' + (cur - 1) + sq + '" class="pagination__prev">&larr; Previous</a>';
      for (var i = 1; i <= total; i++) {
        if (i === cur) h += '<span class="pagination__page pagination__page--current">' + i + '</span>';
        else h += '<a href="' + base + '?page=' + i + sq + '" class="pagination__page">' + i + '</a>';
      }
      if (cur < total) h += '<a href="' + base + '?page=' + (cur + 1) + sq + '" class="pagination__next">Next &rarr;</a>';
      return h + '</nav>';
    }

    var allProducts = [];
    function fetchProducts(page) {
      return fetch('/collections/' + handle + '/products.json?limit=250&page=' + page)
        .then(function (r) { return r.json(); })
        .then(function (data) {
          if (!data.products || !data.products.length) return;
          allProducts = allProducts.concat(data.products);
          if (data.products.length === 250) return fetchProducts(page + 1);
        });
    }

    fetchProducts(1).then(function () {
      var isAvail = function (p) { return p.variants.some(function (v) { return v.available; }); };
      var available = allProducts.filter(isAvail);
      var soldOut = allProducts.filter(function (p) { return !isAvail(p); });

      if (sortBy === 'price-ascending') {
        var byPrice = function (a, b) { return parseFloat(a.variants[0].price) - parseFloat(b.variants[0].price); };
        available.sort(byPrice); soldOut.sort(byPrice);
      } else if (sortBy === 'price-descending') {
        var byPriceDesc = function (a, b) { return parseFloat(b.variants[0].price) - parseFloat(a.variants[0].price); };
        available.sort(byPriceDesc); soldOut.sort(byPriceDesc);
      } else if (sortBy === 'title-ascending') {
        var byTitle = function (a, b) { return a.title.localeCompare(b.title); };
        available.sort(byTitle); soldOut.sort(byTitle);
      } else if (sortBy === 'created-descending') {
        var byDate = function (a, b) { return new Date(b.created_at) - new Date(a.created_at); };
        available.sort(byDate); soldOut.sort(byDate);
      }

      var sorted = available.concat(soldOut);
      var totalPages = Math.ceil(sorted.length / PAGE_SIZE);
      var pageProducts = sorted.slice((currentPage - 1) * PAGE_SIZE, currentPage * PAGE_SIZE);

      var grid = collectionEl.querySelector('.products-grid');
      if (!grid) return;
      grid.innerHTML = pageProducts.map(buildCard).join('');
      grid.querySelectorAll('.product-add-btn').forEach(bindAddToCart);

      var existingNav = collectionEl.querySelector('.pagination');
      var paginationHtml = buildPagination(currentPage, totalPages);
      if (existingNav) {
        existingNav.outerHTML = paginationHtml;
      } else if (paginationHtml) {
        grid.insertAdjacentHTML('afterend', paginationHtml);
      }
    });
  }

  // ── STICKY ATC BAR (mobile product page) ──
  var stickyAtc = document.getElementById('sticky-atc');
  var mainAtcBtn = document.getElementById('add-to-cart-btn');
  var stickyAtcBtn = document.getElementById('sticky-atc-btn');

  if (stickyAtc && mainAtcBtn && 'IntersectionObserver' in window) {
    var atcObserver = new IntersectionObserver(function (entries) {
      stickyAtc.classList.toggle('visible', !entries[0].isIntersecting);
    }, { rootMargin: '0px 0px -20px 0px' });
    atcObserver.observe(mainAtcBtn);
  }

  if (stickyAtcBtn && mainAtcBtn) {
    stickyAtcBtn.addEventListener('click', function () { mainAtcBtn.click(); });
  }

  // ── ESCAPE KEY ──
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') { closeCartDrawer(); closeZoom(); }
  });

});
